import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu", "button"]
  
  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
  }
  
  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }
  
  toggle(event) {
    event.stopPropagation()
    event.preventDefault()
    
    if (this.menuTarget.classList.contains("hidden")) {
      this.open()
    } else {
      this.close()
    }
  }
  
  open() {
    // Close any other open dropdowns first, but not nested ones
    document.querySelectorAll('[data-dropdown-target="menu"]').forEach(menu => {
      if (menu !== this.menuTarget && !this.element.contains(menu)) {
        menu.classList.add("hidden")
      }
    })
    
    this.menuTarget.classList.remove("hidden")
    document.addEventListener("click", this.boundCloseOnClickOutside)
    
    // Add entrance animation
    this.menuTarget.style.opacity = "0"
    this.menuTarget.style.transform = "scale(0.95) translateY(-10px)"
    
    requestAnimationFrame(() => {
      this.menuTarget.style.transition = "all 0.1s ease-out"
      this.menuTarget.style.opacity = "1"
      this.menuTarget.style.transform = "scale(1) translateY(0)"
    })
  }
  
  close() {
    this.menuTarget.classList.add("hidden")
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }
  
  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}